"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isNil_1 = tslib_1.__importDefault(require("./isNil"));
/**
 * Returns an object with all nullable values removed.
 *
 * @example
 * ```ts
 * const compacted = compactObject({ a: 1, b: "b", c: null, d: undefined });
 * // {a: 1, b: "b"}
 * ```
 */
function compactObject(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function (_a) {
        var _b = tslib_1.__read(_a, 2), value = _b[1];
        return !(0, isNil_1.default)(value);
    }));
}
exports.default = compactObject;
//# sourceMappingURL=compactObject.js.map